/* TVC Patches v3
   Loaded AFTER tvc-app.js. Two responsibilities:
   (1) Log every PayPal form submission to Google Sheets.
   (2) For digital products, fix the PayPal modal display + ensure the
       customer is charged product price only (no ₹2500 shipping addition).
   No find/replace in tvc-app.js needed.
*/
(function(){
  var SHEETS_URL = "https://script.google.com/macros/s/AKfycbxK461k_hfW3PhjcK800Bb75YZk3bw5eOKp4kd4Da9mIB5dh-4T7z5GPrTmgj2bryE/exec";

  function val(id){ var el = document.getElementById(id); return el ? (el.value || "").trim() : ""; }

  function getProductPriceNumber(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return 0;
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return 0;
    return parseFloat((spans[1].textContent || "0").replace(/[^\d.]/g, "")) || 0;
  }

  function getProductPriceText(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return "";
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return "";
    return (spans[1].textContent || "").trim();
  }

  function rewritePaypalUrl(url){
    if (typeof url !== "string" || url.indexOf("paypal.me/vediccrystals1") === -1) return url;
    var m = url.match(/(.+\/)([0-9.]+)([A-Z]+)$/);
    if (!m) return url;
    var price = getProductPriceNumber();
    if (price <= 0) return url;
    return m[1] + price.toFixed(2) + m[3];
  }

  function readSummary(){
    var data = { product:"", variant:"", price:"", shipping:"", total:"" };
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    for (var i = 0; i < rows.length; i++) {
      var spans = rows[i].querySelectorAll("span");
      if (spans.length !== 2) continue;
      var lbl = (spans[0].textContent || "").trim();
      var v   = (spans[1].textContent || "").trim();
      if (i === 0) { data.product = lbl; data.price = v; }
      else if (lbl.indexOf("Variant:") === 0) data.variant = lbl.replace(/^Variant:\s*/, "");
      else if (lbl.indexOf("International Shipping") === 0) data.shipping = v;
      else if (lbl === "Total") data.total = v;
    }
    return data;
  }

  // ===== Modal display fix for digital products =====
  function fixModalForDigital(modal){
    if (!modal || !window.__tvcDigitalProduct) return;
    var rows = modal.querySelectorAll(".tvc-pp-checkout-summary-row");
    var shippingRow = null, totalRow = null, priceRow = null;
    for (var i = 0; i < rows.length; i++) {
      var spans = rows[i].querySelectorAll("span");
      if (spans.length !== 2) continue;
      var lbl = (spans[0].textContent || "").trim();
      if (lbl.indexOf("International Shipping") === 0) shippingRow = rows[i];
      else if (lbl === "Total") totalRow = rows[i];
      else if (!priceRow && lbl.indexOf("Variant:") !== 0) priceRow = rows[i];
    }
    if (shippingRow) shippingRow.style.display = "none";
    if (priceRow && totalRow) {
      var pSpans = priceRow.querySelectorAll("span");
      var tSpans = totalRow.querySelectorAll("span");
      if (pSpans.length === 2 && tSpans.length === 2) {
        tSpans[1].textContent = pSpans[1].textContent;
      }
    }
  }

  // ===== Post-submit URL fix for digital products =====
  function fixPostSubmitUrls(modal){
    if (!modal || !window.__tvcDigitalProduct) return;
    var priceText = getProductPriceText();

    // Rewrite all PayPal link hrefs
    var links = modal.querySelectorAll('a[href*="paypal.me/vediccrystals1"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute("href", rewritePaypalUrl(links[i].getAttribute("href")));
      // Update "Pay X Now" text node inside the link
      if (priceText) {
        for (var j = 0; j < links[i].childNodes.length; j++) {
          var node = links[i].childNodes[j];
          if (node.nodeType === 3 && /Pay\s+\S+\s+Now/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/Pay\s+\S+\s+Now/, "Pay " + priceText + " Now");
          }
        }
      }
    }

    // Rewrite the displayed copy-paste URL text
    var divs = modal.querySelectorAll("div");
    for (var k = 0; k < divs.length; k++) {
      if (divs[k].children.length === 0) {
        var txt = (divs[k].textContent || "").trim();
        if (/^https?:\/\/.+paypal\.me\/vediccrystals1\/[0-9.]+[A-Z]+$/.test(txt)) {
          divs[k].textContent = rewritePaypalUrl(txt);
        }
      }
    }

    // Rewrite any heading like "Pay €57.14 via PayPal" to use product price
    if (priceText) {
      var headers = modal.querySelectorAll('div[style*="font-weight:700"]');
      for (var h = 0; h < headers.length; h++) {
        var ht = headers[h].textContent || "";
        if (/^Pay\s+\S+\s+via\s+PayPal/i.test(ht.trim())) {
          headers[h].textContent = ht.replace(/^Pay\s+\S+\s+via/i, "Pay " + priceText + " via");
        }
      }
    }
  }

  // ===== Submit handler: Sheets logging + window.open hijack =====
  document.addEventListener("click", function(evt){
    var t = evt.target;
    if (!t || t.id !== "tvc-pp-submit") return;

    var name    = val("tvc-pp-name");
    var email   = val("tvc-pp-email");
    var phone   = val("tvc-pp-phone");
    var address = val("tvc-pp-address");
    var city    = val("tvc-pp-city");
    var state   = val("tvc-pp-state");
    var zip     = val("tvc-pp-zip");
    var country = val("tvc-pp-country");

    if (!name || !email || !phone || !address || !city || !country) return;

    // For digital products: hijack window.open briefly so the PayPal new-tab URL is corrected
    if (window.__tvcDigitalProduct) {
      var origOpen = window.open;
      window.open = function(url, target, features){
        return origOpen.call(window, rewritePaypalUrl(url), target, features);
      };
      setTimeout(function(){ window.open = origOpen; }, 3000);
    }

    // Log to Sheets
    var sum = readSummary();
    try {
      fetch(SHEETS_URL, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({
          name: name, email: email, phone: phone,
          address: address, city: city, state: state, zip: zip, country: country,
          product: sum.product, variant: sum.variant,
          price: sum.price, shipping: sum.shipping, total: sum.total,
          currency:   window.__saFxTargetCurrency || "INR",
          countryGeo: window.__saGeoCountry || "",
          pageUrl:    window.location.href,
          paypalLink: "",
          isDigital:  !!window.__tvcDigitalProduct,
          submittedAt: new Date().toISOString()
        })
      }).catch(function(){});
    } catch (_) {}
  }, true);

  // ===== Observe DOM for modal lifecycle =====
  if (window.MutationObserver) {
    var modalRef = null;
    new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i++) {
        // Modal first appearing
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains("tvc-pp-checkout-overlay")) {
            modalRef = node;
            (function(n){ setTimeout(function(){ fixModalForDigital(n); }, 10); })(node);
          }
        }
        // Modal subtree mutations (post-submit order summary HTML)
        if (modalRef && mutations[i].target) {
          var tgt = mutations[i].target;
          if (tgt === modalRef || (modalRef.contains && modalRef.contains(tgt))) {
            (function(m){ setTimeout(function(){ fixPostSubmitUrls(m); }, 40); })(modalRef);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
